import React from 'react';
import { MenuButtonState } from './types';

export const MenuButtonContext = React.createContext<MenuButtonState | null>(null);
